var render = function () {var _vm=this;var _h=_vm.$createElement;var _c=_vm._self._c||_h;return _c('span',[(!_vm.type)?_c('p',{staticClass:"alert alert-info"},[_c('fai',{attrs:{"icon":"exclamation-triangle"}}),_vm._v(" "+_vm._s(_vm.trans(_vm.module + '.' + _vm.tip))+" ")],1):_vm._e(),_c('fai',{attrs:{"icon":"exclamation-circle"}})],1)}
var staticRenderFns = []

export { render, staticRenderFns }